import { render, staticRenderFns } from "./kiosk_token_create.vue?vue&type=template&id=160be7f8&"
import script from "./kiosk_token_create.vue?vue&type=script&lang=js&"
export * from "./kiosk_token_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports